var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 331,
    viewBox: "0 0 331 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_190)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 331C256.903 331 331 256.903 331 165.5C331 74.0969 256.903 0 165.5 0C74.0969 0 0 74.0969 0 165.5C0 256.903 74.0969 331 165.5 331Z",
    fill: "#41BBE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_190",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 49,
    width: 235,
    height: 200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.59 49.38H48.4V249H282.59V49.38Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.78 247.47C52.39 210.94 41.56 163.96 56.77 125.07C68.73 94.49 93.85 76.42 101.14 71.52C117.15 60.72 135.51 53.9 154.69 51.63C173.9 49.44 193.36 52.07 211.3 59.28C247.43 74.54 275.06 110.87 280.15 152.61C286.85 207.47 254.48 242.37 249.55 247.47",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.26 203.86C92.22 199.78 90.18 195.7 88.14 191.62",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08 180.91C80.59 149.85 92.22 119.4 115.68 101.35C141.76 81.28 171.22 85.18 176.88 86.05C210.51 91.22 239.74 117.94 245.73 150.31C249.38 170.03 243.33 186.05 241.14 191.62C228.67 223.39 200.15 236.32 193.71 239.05C193.82 230.02 193.94 221 194.05 211.97C194.27 194.08 194.5 176.19 194.72 158.3C194.89 144.96 195.06 131.62 195.24 118.28C195.29 117.72 195.22 117.15 195.03 116.62C194.33 115.01 191.39 114.9 189.99 115.42C187.09 116.51 185.53 120.1 184.53 122.76C182.5 128.16 181.78 133.8 180.67 139.41C178.04 152.69 177.02 166.24 177.62 179.77C177.94 186.89 178.27 194.5 180.4 201.35C181.46 204.77 183.29 207.68 183.87 211.27C184.29 213.88 184.51 216.52 184.52 219.16V243.64C184.52 243.64 156.43 249.76 146.76 243.64V185.5L150.64 179.69L153.8 174.96C154.73 173.56 156.62 171.67 156.85 170.02C156.88 169.77 156.89 169.52 156.88 169.26C156.77 159.22 155.81 149.11 155.25 139.09C154.81 131.19 154.37 123.29 153.93 115.39C153.93 115.3 153.92 115.2 153.92 115.11",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28 115.12V166.97",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58 115.12V166.97",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22 115.12C130.71 123.57 130.21 132.01 129.7 140.46C129.39 145.71 129.07 150.96 128.76 156.21C128.6 158.84 128.44 161.46 128.28 164.09C128.15 166.26 127.47 168.48 128.31 170.59C129.22 172.88 131.31 175.06 132.73 177.08C134.7 179.89 136.66 182.69 138.63 185.5V242.11C138.63 242.11 129.45 240.58 126.39 235.99",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.82 128.21C183.08 146.1 181.53 164.69 183.23 183.12",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331,
    height: 331,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.4baa4cc1f2bddaf3814dc8dcf6a1e34a.svg";
export { ForwardRef as ReactComponent };